<template>
  <div class="news">
    <div class="news-main">
      <div class="news-title" data-aos="fade-up" data-aos-duration="1000">
        <h3>社会责任</h3>
        <p>带您了解网银互联最新动态</p>
      </div>
      <div class="news-wrap" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="200">
        <div class="news-wrap-item" id="newsentp">
          <h3>企业动态</h3>
          <p v-if="newsEntp[0]">{{newsEntp[0].articleAbstract+'...'}}</p>
          <p v-else></p>
          <div class="btn" @click="toDetail(0,2)">More</div>
          <!-- <div class="btn" @click="toDetailItem(newsEntp[0].id)">More</div> -->
        </div>
        <img src="../../../assets/home/news/pic1.png" />
        <div class="news-wrap-item" id="newsprod">
          <h3>产品动态</h3>
          <p v-if="newsProd[0]">{{newsProd[0].articleAbstract+'...'}}</p>
          <p v-else></p>
          <div class="btn" @click="toDetail(0,1)">More</div>
          <!-- <div class="btn" @click="toDetailItem(newsProd[0].id)">More</div> -->
        </div>
        <img src="../../../assets/home/news/pic2.png" />
        <div class="news-wrap-item" id="newsindu">
          <h3>行业动态</h3>
          <p v-if="newsIndu[0]">{{newsIndu[0].articleAbstract+'...'}}</p>
          <p v-else></p>
          <div class="btn" @click="toDetail(0,3)">More</div>
          <!-- <div class="btn" @click="toDetailItem(newsIndu[0].id)">More</div> -->
        </div>
        <img src="../../../assets/home/news/pic3.png" />
      </div>
    </div>
  </div>
</template>
<script>
import newsinfo from "../../about/newinfos";
import newinfosB from "../../about/newinfosB";
import newinfosC from "../../about/newinfosC";
import Swiper from "swiper/dist/js/swiper.js";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { Pagination, Loading } from 'element-ui';
export default {
  components: { swiper, swiperSlide, Pagination, Loading },
  data() {
    return {
      newsinfo: newsinfo,
      newsinfoB: newinfosB,
      newsinfoC: newinfosC,
      newsProd: [],//产品
      newsEntp: [],//企业
      newsIndu: [],//行业
    };
  },

  methods: {
    toNews() {
      let routeData = this.$router.resolve({
        path: "/about/News"
      });
      window.open(routeData.href, "_blank");
    },
    toDetailItem(id, type) {
      let routeData = this.$router.resolve({
        path: "/about/NewsDetail",
        query: { id: id }
      });
      window.open(routeData.href, "_blank");
    },
    toDetail() {
      let url = "/about/News";
      if (url) {
        let a = document.createElement("a");
        a.setAttribute("href", url);
        a.setAttribute("id", "startTelMedicine");
        // 防止反复添加
        if (document.getElementById("startTelMedicine")) {
          document.body.removeChild(
            document.getElementById("startTelMedicine")
          );
        }
        document.body.appendChild(a);
        a.click();
      }
    }
  },
  mounted() {

    let loadingInstanceProd = Loading.service({ target: "#newsprod" }),
      loadingInstanceEntp = Loading.service({ target: "#newsentp" }),
      loadingInstanceIndu = Loading.service({ target: "#newsindu" });
    // 
    this.dispatchExtend('getNetbankArticle', { type: "0", size: 1 }).then(result => {
      this.newsProd = result.data.records || []
      loadingInstanceProd.close();
    });
    this.dispatchExtend('getNetbankArticle', { type: "1", size: 1 }).then(result => {
      this.newsEntp = result.data.records || []
      loadingInstanceEntp.close();
    });
    this.dispatchExtend('getNetbankArticle', { type: "2", size: 1 }).then(result => {
      this.newsIndu = result.data.records || []
      loadingInstanceIndu.close();
    });

    var that = this;
    that.$nextTick(function () {
      let certifySwiper = new Swiper("#certify .swiper-container", {
        watchSlidesProgress: true,
        slidesPerView: "auto",
        centeredSlides: true,
        loop: true,
        loopedSlides: 3,
        autoplay: {
          disableOnInteraction: false
        },
        on: {
          progress: function (progress) {
            // console.log(this.slides);
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i);
              var slideProgress = this.slides[i].progress;
              let modify = 1;
              if (Math.abs(slideProgress) > 1) {
                modify = (Math.abs(slideProgress) - 1) * 1.1 + 1;
              }
              var translate = slideProgress * modify * 100 + "px";
              var scale = 1 - Math.abs(slideProgress) / 5;
              var zIndex = 999 - Math.abs(Math.round(10 * slideProgress));

              slide.transform(
                "translateX(" + translate + ") scale(" + scale + ")"
              );
              slide.css("zIndex", zIndex);
              slide.css("opacity", 1);
              if (Math.abs(slideProgress) > 3) {
                slide.css("opacity", 0);
              }
            }
          },

          setTransition: function (transition) {
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i);
              slide.transition(transition);
            }
          }
        }
      });
    });
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-loading-spinner .path {
  stroke: #b81c22;
}
.news {
  height: 540px;
  width: 100%;
  min-width: 1200px;
  // position: relative;
  // background-size: 1980px 520px;
  // background-position: center;
  // background-image: url("../../../assets/home/news/newsbg.png");
}
.news-main {
  height: 100%;
  width: 1200px;

  margin: 0 auto;
  .news-title {
    width: 1200px;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 50px;
    text-align: center;

    h3 {
      font-size: 28px;
      color: #3b3435;
    }
    p {
      margin-top: 20px;
      font-size: 16px;
      font-weight: 300;
      color: #aba1a2;
    }
  }
  .news-wrap {
    width: 1110px;
    height: 400px;
    display: -webkit-flex; /* Safari */
    display: flex;
    flex-wrap: wrap;
    margin: 0 auto;
    .news-wrap-item {
      width: 370px;
      height: 200px;
      padding: 20px;
      border: 1px solid #f7f2f2;
      text-align: center;
      h3 {
        font-size: 18px;
        margin-bottom: 27px;
        position: relative;
        &:after {
          content: "";
          width: 50px;
          height: 2px;
          background-color: #df0020;
          position: absolute;
          bottom: -6px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
      p {
        min-height: 60px;
        font-size: 14px;
        line-height: 20px;
      }
      .btn {
        width: 70px;
        height: 24px;
        color: #b81c22;
        margin: 0 auto;
        margin-top: 25px;
        text-align: center;
        line-height: 22px;
        border-radius: 12px;
        border: 1px solid #b81c22;
        position: relative;
        transition: all 0.3s;
        overflow: hidden;
        cursor: pointer;
        &:before {
          content: "";
          width: 0px;
          height: 24px;

          background-color: #b81c22;
          position: absolute;
          left: -2px;
          top: -2px;
          z-index: -1;
          transition: all 0.4s;
        }
        &:hover {
          color: #fff;
          &:before {
            content: "";
            width: 72px;
            height: 26px;

            background-color: #b81c22;
            position: absolute;

            z-index: -1;
          }
        }
      }
    }
    img {
      width: 370px;
      height: 200px;
    }
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05), 0 0 30px 0 rgba(0, 0, 0, 0.1);
  }
  .news-wrap-old {
    height: 280px;
    width: 100%;
    #certify {
      position: relative;
      width: 1200px;
      margin: 0 auto;
    }
    #certify .swiper-slide {
      width: 340px;
      height: 280px;
      background: #fff;
      box-shadow: -1px 5px 22px 2px rgba(51, 51, 51, 0.16);
      .topbar {
        height: 10px;
        width: 100%;
        background-color: #fff;

        float: left;
      }
      .infobox {
        padding-top: 0px;
        margin: 0 15px;
        // background-color: #ccc;
        .date {
          color: #e4e4e4;
          font-size: 34px;
          font-weight: bold;
          line-height: 70px;
        }
        .title {
          h2 {
            font-size: 18px;
            font-weight: 800;
            color: #eb585f;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .newses {
          text-indent: 18px;
          margin-top: 30px;
          font-size: 14px;
          color: #666;
          line-height: 18px;
        }
        .btn {
          margin-top: 35px;
          width: 120px;
          height: 40px;
          border: 1px solid rgba(236, 112, 103, 1);
          text-align: center;
          border-radius: 5px;
          cursor: pointer;
          p {
            font-size: 16px;
            line-height: 40px;
            color: rgba(236, 112, 103, 1);
          }

          display: none;
        }
      }
    }
    #certify .swiper-slide-active {
      .topbar {
        background-color: #ec3848;
      }
      .infobox {
        .btn {
          display: block;
        }
      }
    }
    #certify .swiper-slide-prev {
      padding-top: 10px;
    }
    #certify .swiper-slide-next {
    }
    #certify .swiper-slide img {
      display: block;
    }
    #certify .swiper-slide p {
      line-height: 98px;
      padding-top: 0;
      text-align: center;
      color: #636363;
      font-size: 1.1em;
      margin: 0;
    }
    #certify .swiper-pagination {
      width: 100%;
      bottom: 20px;
    }
    #certify .swiper-pagination-bullets .swiper-pagination-bullet {
      margin: 0 5px;
      border: 3px solid #fff;
      background-color: #d5d5d5;
      width: 10px;
      height: 10px;
      opacity: 1;
    }
    #certify .swiper-pagination-bullets .swiper-pagination-bullet-active {
      border: 3px solid #00aadc;
      background-color: #fff;
    }
    #certify .swiper-button-prev {
      left: -30px;
      width: 45px;
      height: 45px;
      background-position: 0 0;
      background-size: 100%;
    }
    #certify .swiper-button-prev:hover {
      background-position: 0 -46px;
      background-size: 100%;
    }
    #certify .swiper-button-next {
      right: -30px;
      width: 45px;
      height: 45px;

      background-position: 0 -93px;
      background-size: 100%;
    }
    #certify .swiper-button-next:hover {
      background-position: 0 -139px;
      background-size: 100%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/home/components/news.vue